/* eslint no-console: "off" */
import common from '../common/index';

export default {
  resetPrizePostGameData(state) {
    state.unauthorizedWinnerInfo.msisdn = null;
    state.unauthorizedWinnerInfo.code = null;
    state.unauthorizedWinnerInfo.gameType = null;
    state.unauthorizedWinnerInfo.prizeId = null;
    state.unauthorizedWinnerInfo.name = null;
    state.unauthorizedWinnerInfo.imageWonUrl = null;
    state.unauthorizedWinnerInfo.existPrize = false;
  },
  updateUnauthorizedWinnerInfo(state) { // retrieves data from Vuex to pass them to home page
    state.unauthorizedWinnerInfo.msisdn = common.state.unauthorizedMsisdn;
    state.unauthorizedWinnerInfo.code = common.state.code;
    state.unauthorizedWinnerInfo.gameType = state.gameType;
    state.unauthorizedWinnerInfo.prizeId = state.playersDetails.winDTO.id;
    state.unauthorizedWinnerInfo.name = state.playersDetails.winDTO.name;
    state.unauthorizedWinnerInfo.imageWonUrl = state.playersDetails.winDTO.imageWonUrl;
    state.unauthorizedWinnerInfo.existPrize = true;
  },
  isGamePageFlow(state, booleanVal) {
    state.isGamePage = booleanVal;
  },
  updateGameType(state, gameType) {
    state.gameType = gameType;
  },
  setUserLeveledUp(state, userLeveledUp) {
    state.playersDetails.levelUp = userLeveledUp;
  },
  resetGameState(state) {
    state.gameInProgress = false;
    state.gameID = null;
    state.gameFinished = false;
    state.gameType = '';
    state.isGamePage = null;
    state.attemptsUsed = null;
    state.gameCardDTOS = [];
  },
  resetPrizeData(state) {
    state.playersDetails = [];
  },
  updatePrizePostGameData(state, payload) {
    state.playersDetails.winDTO = payload.winDTO;
    state.playersDetails.lostDTOs = payload.lostDTOs;
  },
  setPlayersPostGameData(state, payload) {
    // store home player post game data
    state.playersDetails.postgamePointsFromCorrectAnswers = payload.postgamePointsFromCorrectAnswers;
    state.playersDetails.postgamePointsFromRoundsWon = payload.postgamePointsFromRoundsWon;
    state.playersDetails.postgamePointsFromGameWon = payload.postgamePointsFromGameWon;
    state.playersDetails.postgamePointsTotal = payload.postgamePointsTotal;
    state.playersDetails.levelUpPoints = payload.levelUpPoints;
    state.playersDetails.currentLevel = payload.currentLevel;
    state.playersDetails.gamesToNextLevel = payload.gamesToNextLevel;
    state.playersDetails.currentLevelGamesWon = payload.currentLevelGamesWon;
  },
  setShuffledCardDTOS(state, payload) {
    state.shuffledCardDTOS = payload.sdCardsShuffled;
  },
  setGameType(state, payload) {
    state.gameType = payload.gameType;
  },
  setGameAttempts(state, payload) {
    state.attemptsUsed = payload.attemptsUsed;
  },
  setGameCardDTOS(state, payload) {
    state.gameCardDTOS = payload.gameCardDTOS;
  },
  setGameDTOForResumeGameOnly(state, gameStateEnumForResumeGame) {
    state.gameStateEnumForResumeGame = gameStateEnumForResumeGame;
  },
  setTransitionOnlyForSearchingToOpponent(state, value) {
    state.transitionOnlyForSearchingToOpponent = value;
  },
  setGameInProgress(state, gameInProgress) {
    state.gameInProgress = gameInProgress;
  },
  setGameID(state, gameID) {
    state.gameID = gameID;
  },
  setGameFinishedStatus(state, gameFinished) {
    state.gameFinished = gameFinished;
  },
  storeRegistrationPoints(state, points) {
    state.registrationPoints = points;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/mutations.js